var exports = {
  "Kk": "InviteEmbed.module__icon___QzhBam",
  "EU": "InviteEmbed.module__iconFallback___QzhBam",
  "C1": "InviteEmbed.module__titleRowWithIcon___QzhBam",
  "gn": "InviteEmbed.module__titleContainer___QzhBam",
  "Qw": "InviteEmbed.module__titleText___QzhBam",
  "fH": "InviteEmbed.module__headerInvite___QzhBam",
  "dT": "InviteEmbed.module__inviteWrapper___QzhBam",
  "M1": "InviteEmbed.module__stats___QzhBam",
  "dJ": "InviteEmbed.module__stat___QzhBam",
  "gW": "InviteEmbed.module__statDot___QzhBam",
  "rR": "InviteEmbed.module__statDotOnline___QzhBam",
  "rb": "InviteEmbed.module__statDotMembers___QzhBam",
  "KA": "InviteEmbed.module__statText___QzhBam",
};

module.exports = exports;
